import { compact, uniq } from 'lodash';

interface IDesignFonts {
  loadFonts: string[];
  variables: { [key: string]: string };
}

interface ITemplateDefaults {
  newDefaultDesign?: { iconSet?: string; headingFont?: string };
}

/**
 * The icon set and heading font a template starts a gallery with. The gallery loads only the
 * fonts in `loadFonts`, so the heading font replaces whatever the previous template added there.
 * A gallery preset without a font has no `variables` at all.
 */
export const templateDefaultDesign = (
  template: ITemplateDefaults | undefined,
  design: Partial<IDesignFonts>
): Partial<IDesignFonts & { iconSet: string }> => {
  const { iconSet, headingFont } = template?.newDefaultDesign || {};

  return {
    ...(iconSet && { iconSet }),
    ...(headingFont && {
      loadFonts: uniq(compact([design.variables?.font, headingFont])),
      variables: { ...design.variables, headingFont }
    })
  };
};
